<template>
  <div class="price_con">
    <h3>{{ $t("lang.电价管理") }}</h3>
    <div class="price_con_boxs">
      <div class="price_box" v-for="item in priceList" :key="item.priceId">
        <p>{{ item.priceName }}</p>
        <div class="price_value">
          <i class="icon-electric iconfont"></i>
          <span>{{ item.priceValue.toFixed(2) }}</span>
          <span>{{ monetary + "/kWh" }}</span>
        </div>
        <div class="price_button">
          <i class="el-icon-edit" @click="operationPrice(2, item)"></i>
          <i class="el-icon-delete" @click="onClickDelPrice(item.priceId)"></i>
        </div>
      </div>
      <div class="price_add" @click="operationPrice(1)">
        <i class="iconfont icon-jiahao"></i>
      </div>
    </div>
    <ElectricityDialog ref="electricityDialogRef" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ElectricityDialog from "../dialog/electricity-dialog.vue";
export default {
  components: { ElectricityDialog },
  data() {
    return {
      priceList: [],
      monetary: "元",
    };
  },
  created() {
    this.getPriceList();
  },
  mounted() {
    let that = this;
    this.$bus.$on("updateCurrency", function () {
      that.getPriceList();
    });
  },
  methods: {
    ...mapActions({
      electricityPricesList: "ZD_ElectricityPricesList",
      electricityPricesDelete: "ZD_ElectricityPricesDelete",
    }),
    async getPriceList() {
      this.monetary = localStorage.getItem("monetary");
      let res = await this.electricityPricesList({});
      if (res.success !== 1) return;
      this.priceList = res.listitem;
    },
    operationPrice(type, item) {
      this.$refs.electricityDialogRef.showDialog(type, item);
    },
    onClickDelPrice(priceId) {
      this.$confirm(
        this.$t("lang.您是否确认要删除该价格"),
        this.$t("lang.删除电价"),
        {
          confirmButtonText: this.$t("lang.确定"),
          cancelButtonText: this.$t("lang.取消"),
          type: "warning",
        }
      )
        .then(async () => {
          let res = await this.electricityPricesDelete({
            value: { priceId: priceId },
          });
          if (res.success !== 1) retuen;
          this.$message({
            type: "success",
            message: this.$t("lang.删除成功"),
          });
          this.getPriceList();
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang='less'>
.price_con {
  border-right: 1px solid #eee;
  padding: 20px 0px 0px 20px;
}
h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: inherit;
}
.price_con_boxs {
  padding: 36px 0 0 20px;
  display: flex;
  flex-wrap: wrap;
}
water_price_con_boxs{
  padding: 36px 0 0 20px;
  display: flex;
  flex-wrap: wrap;
}
.price_box {
  width: 180px;
  height: 90px;
  background: #edf5ff;
  border-radius: 4px;
  margin-right: 20px;
  margin-bottom: 20px;
  color: #666;
  position: relative;
  p {
    font-size: 14px;
    margin: 5px 0 15px 10px;
    color: #666;
  }
  .price_value {
    text-align: center;
    i {
      color: #fdb344;
      font-size: 14px;
      margin-right: 8px;
    }
    span:nth-of-type(1) {
      font-weight: bold;
      font-size: 16px;
      margin-right: 2px;
    }
    span:nth-of-type(2) {
      font-size: 14px;
    }
  }
  .price_button {
    position: absolute;
    right: 15px;
    top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 70px;
    i {
      cursor: pointer;
    }
  }
}
.price_add {
  width: 180px;
  height: 90px;
  border-radius: 4px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  i {
    font-size: 24px;
    color: #ccc;
    font-weight: bold;
  }
}
</style>
